const heroModules = document.querySelectorAll('.hero-module');
const controller = new ScrollMagic.Controller();

heroModules.forEach((el) => {
  if (windowWidth() > breakpointMd) {
    const heroBackground = el.querySelector('.hero-module__background-inner');

    // Background animation
    const stickyTween = gsap.to(heroBackground, {
      yPercent: 60,
      autoAlpha: 0.4,
    });

    new ScrollMagic.Scene({
      triggerElement: el,
      triggerHook: 0,
      duration: '200%',
    })
      .setTween(stickyTween)
      .addTo(controller);
  }
});
